import React, { useEffect, useRef } from "react";
import "../../styles/animatica.css";
import invest_icon1 from "../../assets/images/svg/invest_icon.svg";
import invest_icon2 from "../../assets/images/svg/insta_icon1.svg";
import invest_icon3 from "../../assets/images/svg/insta_icon2.svg";
import { tiltHandlers } from "./useTilt";

const investCards = [
  {
    icon: invest_icon1,
    title: (
      <>
        Government-sponsored <br />schemes
      </>
    ),
    text: (
      <>
        Tap into state-backed funding<br /> opportunities.
      </>
    ),
    delay: "an-reveal-d1",
  },
  {
    icon: invest_icon2,
    title: "Content monetization",
    text: "Create and market premium animated content through platforms like YouTube and OTT giants.",
    delay: "an-reveal-d2",
  },
  {
    icon: invest_icon3,
    title: (
      <>
        AICTE-approved diploma <br />courses
      </>
    ),
    text: "Attract students seeking industry-ready certifications",
    delay: "an-reveal-d3",
  },
];

const AnimaticaWhyInvestHero = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="an-section py-5">
      <div className="an-glow an-glow-left" />
      <div className="an-glow an-glow-right" />
      <div className="container py-md-5 py-4 position-relative">
        <h2 className="an-reveal fs_35 ff_s fw-bold text-center text-navy mb-0">
          Why Invest in <span className="text-white">ICASA?</span>
        </h2>
        <div className="an-reveal an-divider mx-auto" />
        <div className="row mt-md-5 pt-4">
          {investCards.map((card, index) => (
            <div
              key={index}
              className={`an-reveal ${card.delay} col-md-4 col-sm-6 mt-4`}
            >
              <div
                className="an-glass an-tilt h-100 p-4 pt-5 text-center rounded-4 position-relative"
                {...tiltHandlers}
              >
                <div className="an-icon-halo mx-auto position-absolute start-50 translate-middle-x" style={{ top: "-32px" }}>
                  <img src={card.icon} alt="invest_icon" />
                </div>
                <h3 className="mt-3 fs_20 fw-bolder mb-0 text-navy">
                  {card.title}
                </h3>
                <p className="fs_18 fw-medium mb-0 mt-2" style={{ color: "rgba(248, 250, 252, 0.68)" }}>
                  {card.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnimaticaWhyInvestHero;
